import { createContext } from "react"

export type Decision = {
    projectId: number
    decisionId: number
    date: Date
    workstream: string
    workstreamId: number
    workPackage: string
    workPackageId: number
    raisedBy: string
    description: string
    decider: string
    userId: string
    dateMade: Date
    status: "Closed" | "Cancelled" | "Open"
    notes: string
    seen: boolean
    acknowledged: boolean
}

interface DecisionContextProps {
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    decisionTableDemoContent: Decision[];
    setDecisionTableDemoContent: (content: Decision[]) => void;
    showPopup: (decision: Decision) => void;
    demoMode: boolean;
    setDemoMode: (mode: boolean) => void;
    rowSelection: {};
    setRowSelection: React.Dispatch<React.SetStateAction<{}>>;
    addDecision: () => void;
}

export const DecisionContext = createContext<DecisionContextProps>({
    dialogOpen: false,
    setDialogOpen: () => {},
    decisionTableDemoContent: [],
    setDecisionTableDemoContent: () => {},
    showPopup: () => {},
    demoMode: false,
    setDemoMode: () => {},
    rowSelection: {},
    setRowSelection: () => {},
    addDecision: () => {},
});
